import React from 'react';
import {
  Row,
  Col,
  Form,
  Button,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import Currency from 'helpers/Currency';
import { parseDate } from 'helpers/date';
import PadLock from 'components/PadLock';
import style from './style.module.scss';

export function Invoices({
  invoices,
  setHidden,
  setShowModal,
  setIsInvoice,
  editable,
  hidden,
  setCurrency,
  t,
}) {
  return (
    <Row className="mt-3 mb-2">
      <Col>
        {!editable ? <PadLock /> : null}
        <Row>
          <Col>
            <h4>{t('title:invoices')}</h4>
          </Col>
          <Col className="text-right">
            {' '}
            {hidden ? (
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>{t('label:expand')}</Tooltip>}
              >
                <i
                  className="expenseDescriptionIcon fas fa-plus"
                  onClick={() => setHidden(false)}
                />
              </OverlayTrigger>
            ) : (
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>{t('label:minimize')}</Tooltip>}
              >
                <i
                  className="expenseDescriptionIcon fas fa-minus"
                  onClick={() => setHidden(true)}
                />
              </OverlayTrigger>
            )}
          </Col>
        </Row>

        <Col
          className={`${style.expenseDescription} ${
            hidden ? style.hidden : null
          }`}
        >
          {invoices?.map((invoice, k) =>
            invoice.invoice ? (
              <Row className="mt-3" key={k}>
                <Row>
                  <Col>
                    <Form.Group>
                      <Form.Label>{t('label:number')}</Form.Label>
                      <Form.Control value={invoice.number} disabled />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label>{t('label:value')}</Form.Label>
                      <Currency value={invoice.value} disabled />
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="ml-3">
                  <Col>
                    <Form.Group>
                      <Form.Label>{t('label:expiry')}</Form.Label>
                      <DatePicker
                        className="form-control"
                        dateFormat="dd/MM/yyyy"
                        locale="pt_BR"
                        selected={new Date(parseDate(invoice.due_date))}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <p>Visualizar/Download</p>
                    <Button
                      href={invoice.file?.uri}
                      variant="light"
                      alt={t('label:nf preview')}
                      size="sm"
                      target="_blank"
                      title={t('label:nf preview')}
                    >
                      <i className="fas fa-external-link-alt" />
                    </Button>
                  </Col>
                </Row>
              </Row>
            ) : (
              <Row className="mt-3" key={k}>
                <Row>
                  <Col>
                    <Form.Group>
                      <Form.Label>{t('label:number')}</Form.Label>
                      <Form.Control value={invoice.number} disabled />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label>{t('label:value')}</Form.Label>
                      <Currency value={invoice.value} disabled />
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="ml-3">
                  <Col>
                    <Form.Group>
                      <Form.Label>{t('label:expiry')}</Form.Label>
                      <DatePicker
                        className="form-control"
                        dateFormat="dd/MM/yyyy"
                        locale="pt_BR"
                        selected={new Date(parseDate(invoice.due_date))}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <p>Visualizar/Download</p>
                    <Button
                      href={invoice.file?.uri}
                      variant="light"
                      alt={t('label:nf preview')}
                      size="sm"
                      target="_blank"
                      title={t('label:nf preview')}
                    >
                      <i className="fas fa-external-link-alt" />
                    </Button>
                  </Col>
                </Row>
              </Row>
            )
          )}
        </Col>
        <Row className="mt-3">
          <Col>
            <Button
              size="sm"
              variant="dark"
              onClick={() => {
                setShowModal(true);
              }}
            >
              <i className="fas fa-plus" /> {t('label:add new debit invoice')}
            </Button>
            &nbsp;
            <Button
              size="sm"
              variant="dark"
              onClick={() => {
                setShowModal(true);
                setIsInvoice(true);
              }}
            >
              <i className="fas fa-plus" /> {t('label:add new invoice')}
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
